<template>
  <div class="md:hidden">
    <div class="bg-white">
      <form @submit.prevent="signIn()">
        <div class="flex flex-col justify-center items-center">
          <div class="flex flex-col items-center justify-between gap-16 pt-4">
            <svg
              id="b"
              xmlns="http://www.w3.org/2000/svg"
              width="150.248"
              height="80.619"
              viewBox="0 0 150.248 80.619"
            >
              <g id="c">
                <g id="Group_28" data-name="Group 28">
                  <g
                    id="Group_25"
                    data-name="Group 25"
                    transform="translate(45.768 9.375)"
                  >
                    <g
                      id="Group_24"
                      data-name="Group 24"
                      transform="translate(34.997 8.237)"
                    >
                      <rect
                        id="Rectangle_38"
                        data-name="Rectangle 38"
                        width="9.375"
                        height="9.375"
                        transform="translate(9.375 0) rotate(90)"
                      />
                      <path
                        id="Path_19"
                        data-name="Path 19"
                        d="M186.944,85.83v40.409H177.61V85.83Z"
                        transform="translate(-177.587 -64.402)"
                      />
                    </g>
                    <path
                      id="Path_20"
                      data-name="Path 20"
                      d="M217.774,20.61V90.685H208.44V20.61Z"
                      transform="translate(-159.397 -20.61)"
                    />
                    <path
                      id="Path_21"
                      data-name="Path 21"
                      d="M235.55,104.4a20.088,20.088,0,0,1,6.263-14.9,22.1,22.1,0,0,1,30.621.041,21.64,21.64,0,0,1-.041,30.412,21.4,21.4,0,0,1-15.474,6.1,20.454,20.454,0,0,1-15.229-6.222A20.929,20.929,0,0,1,235.55,104.4Zm9.543.164q0,6.059,3.234,9.584a12.584,12.584,0,0,0,17.512.041q3.275-3.527,3.279-9.42t-3.279-9.42a11.4,11.4,0,0,0-8.756-3.566,11.2,11.2,0,0,0-8.67,3.566,12.976,12.976,0,0,0-3.32,9.211Z"
                      transform="translate(-174.176 -54.818)"
                    />
                    <path
                      id="Path_22"
                      data-name="Path 22"
                      d="M118.086,67.242l17.548-16.971H123.1l-13.15,13.068V20.61H105.31V25.3h-4.69V90.685h9.334V75.124l1.5-1.492,13.359,17.053h12.117L118.091,67.242Z"
                      transform="translate(-100.62 -20.61)"
                    />
                  </g>
                  <g id="Group_27" data-name="Group 27">
                    <g
                      id="Group_26"
                      data-name="Group 26"
                      transform="translate(0 4.69)"
                    >
                      <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M31.7,25.3V54.965Q26.1,49.152,19,49.157a17.333,17.333,0,0,0-13.564,6.1A21.738,21.738,0,0,0,0,70.358,22.779,22.779,0,0,0,5.436,85.8a17.773,17.773,0,0,0,13.773,6.059A17.413,17.413,0,0,0,31.7,86.46v4.23h9.379V29.985h-4.69V25.3H31.7ZM29.088,79.941a10.718,10.718,0,0,1-8.383,3.571,10.207,10.207,0,0,1-8.051-3.693,14.083,14.083,0,0,1-3.111-9.461,13.459,13.459,0,0,1,3.2-9.129,10.316,10.316,0,0,1,8.051-3.648,10.546,10.546,0,0,1,8.3,3.612,13.815,13.815,0,0,1,3.193,9.375,13.828,13.828,0,0,1-3.193,9.379ZM41.078,20.61h-4.69V25.3h4.69Z"
                        transform="translate(0 -15.925)"
                        fill="#369da3"
                      />
                      <rect
                        id="Rectangle_39"
                        data-name="Rectangle 39"
                        width="4.69"
                        height="4.69"
                        transform="translate(31.699)"
                        fill="#369da3"
                      />
                      <rect
                        id="Rectangle_40"
                        data-name="Rectangle 40"
                        width="4.69"
                        height="4.69"
                        transform="translate(41.078)"
                        fill="#369da3"
                      />
                    </g>
                    <rect
                      id="Rectangle_41"
                      data-name="Rectangle 41"
                      width="4.69"
                      height="4.69"
                      transform="translate(50.457)"
                      fill="#369da3"
                    />
                  </g>
                </g>
              </g>
            </svg>

            <h1 class="font-bold text-[30px] my-6 text-left">Sign in</h1>
          </div>
          <label class="relative p-0 my-4 w-[90%] bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              class="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g
                id="Group_16107"
                data-name="Group 16107"
                transform="translate(-683 -292)"
              >
                <circle
                  id="Ellipse_1211"
                  data-name="Ellipse 1211"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(683 292)"
                  fill="none"
                  opacity="0.3"
                />
                <path
                  id="envelope_2_"
                  data-name="envelope (2)"
                  d="M13.221,1H3.479A3.483,3.483,0,0,0,0,4.479v8.35a3.483,3.483,0,0,0,3.479,3.479h9.742A3.483,3.483,0,0,0,16.7,12.829V4.479A3.483,3.483,0,0,0,13.221,1ZM3.479,2.392h9.742A2.088,2.088,0,0,1,15.155,3.7L9.827,9.034a2.092,2.092,0,0,1-2.953,0L1.545,3.7A2.088,2.088,0,0,1,3.479,2.392Zm9.742,12.525H3.479a2.088,2.088,0,0,1-2.088-2.088V5.523l4.5,4.5a3.484,3.484,0,0,0,4.921,0l4.5-4.5v7.306A2.088,2.088,0,0,1,13.221,14.917Z"
                  transform="translate(692.15 300.846)"
                  fill="#adadad"
                />
              </g>
            </svg>
            <input
              class="block w-full bg-inputbg pl-12 rounded-[5px] h-12 py-1 outline-none border-none focus:bg-gray-200"
              type="email"
              placeholder="Email"
              v-model="inEmail"
              required
              @blur="validateEmail"
            />
          </label>
          <label class="relative p-0 mt-4 mb-1 w-[90%] bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              class="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g
                id="Group_16110"
                data-name="Group 16110"
                transform="translate(-496 -354)"
              >
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(496 354)"
                  fill="none"
                  opacity="0.3"
                />
                <g id="lock" transform="translate(503.917 362.4)">
                  <path
                    id="Path_25415"
                    data-name="Path 25415"
                    d="M14.892,6.388V5.308a5.308,5.308,0,1,0-10.617,0v1.08A3.792,3.792,0,0,0,2,9.858v4.55A3.8,3.8,0,0,0,5.792,18.2h7.583a3.8,3.8,0,0,0,3.792-3.792V9.858A3.792,3.792,0,0,0,14.892,6.388Zm-9.1-1.08a3.792,3.792,0,1,1,7.583,0v.758H5.792Zm9.858,9.1a2.275,2.275,0,0,1-2.275,2.275H5.792a2.275,2.275,0,0,1-2.275-2.275V9.858A2.275,2.275,0,0,1,5.792,7.583h7.583A2.275,2.275,0,0,1,15.65,9.858Z"
                    transform="translate(0)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25416"
                    data-name="Path 25416"
                    d="M11.758,14a.758.758,0,0,0-.758.758v1.517a.758.758,0,0,0,1.517,0V14.758A.758.758,0,0,0,11.758,14Z"
                    transform="translate(-2.175 -3.383)"
                    fill="#adadad"
                  />
                </g>
              </g>
            </svg>

            <input
              class="block w-full bg-inputbg pl-12 rounded-[5px] h-12 py-1 outline-none border-none focus:bg-gray-200"
              :type="[enable ? 'text' : 'password']"
              placeholder="Password"
              v-model="inPassword"
              required
            />
            <svg
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              @click="enablePass()"
              v-if="enable == false"
            >
              <g
                id="Group_16847"
                data-name="Group 16847"
                transform="translate(-0.4)"
              >
                <path
                  id="eye-crossed"
                  d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                  transform="translate(8.768 8.494)"
                />
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(0.4)"
                  fill="none"
                  opacity="0.3"
                />
              </g>
            </svg>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.315"
              height="11.923"
              viewBox="0 0 15.315 11.923"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              v-if="enable == true"
              @click="enablePass()"
            >
              <g id="eye" transform="translate(0.004 -2.655)">
                <path
                  id="Path_26662"
                  data-name="Path 26662"
                  d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_26663"
                  data-name="Path 26663"
                  d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                  transform="translate(-2.536 -1.573)"
                />
              </g>
            </svg>
          </label>
          <div class="flex flex-row justify-end w-[90%] mb-6">
            <div>
              <p class="text-[16px]" @click="goTo()">Forgot password ?</p>
            </div>
          </div>
          <div
            class="font-normal text-red-600 flex justify-center w-[90%]"
            v-if="_formIsValid"
          >
            Whoops! Something went wrong. <br />
            Please enter a valid Email address
          </div>

          <div
            class="font-normal text-red-600 flex justify-center w-[90%]"
            v-if="afterMailSend"
          >
            {{ message }}
          </div>

          <div
            class="font-normal text-red-600 flex justify-center"
            v-if="checkEmail"
          >
            Please enter your email !
          </div>
          <button
            class="bg-primary text-white rounded-[5px] py-3 px-24 w-[90%]"
          >
            Submit
          </button>
          <div class="flex flex-row justify-center items-center py-4">
            <p class="text-[16px]">Create an account ?</p>
            <p
              class="text-[12px] text-primary ml-2 cursor-pointer"
              @click="$router.push('/sign-up')"
            >
              Sign Up
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="container md:flex hidden" id="container">
    <div class="form-container sign-up-container bg-white">
      <form @submit.prevent="submitForm" class="l-form" v-if="!isSuccesful">
        <!-- <div v-if="errors">
                    {{ errors }}
                    <div v-for="error in errors" :key="error">
                        <div
                            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                            role="alert"
                        >
                            <strong class="font-bold capitalize">{{ error }} :</strong>
                            <span class="block sm:inline">{{ error }}.</span>
                        </div>
                    </div>
                </div> -->
        <div>
          <div class="flex flex-col justify-around h-full">
            <div class=" ">
              <h1 class="font-bold text-[37px] mb-4 text-left">Sign up</h1>
            </div>
            <div class="flex flex-row gap-2 w-full">
              <div class="flex flex-col w-full">
                <label
                  class="relative p-0 my-2 text-gray-400 w-full bg-white focus-within:text-gray-600 block"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.999"
                    height="15.999"
                    viewBox="0 0 11.999 15.999"
                    class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
                  >
                    <g
                      id="user_3_"
                      data-name="user (3)"
                      transform="translate(-3)"
                    >
                      <path
                        id="Path_25867"
                        data-name="Path 25867"
                        d="M10,8A4,4,0,1,0,6,4a4,4,0,0,0,4,4Zm0-6.666A2.666,2.666,0,1,1,7.333,4,2.666,2.666,0,0,1,10,1.333Z"
                        transform="translate(-1)"
                        fill="#adadad"
                      />
                      <path
                        id="Path_25868"
                        data-name="Path 25868"
                        d="M9,14a6.006,6.006,0,0,0-6,6,.667.667,0,1,0,1.333,0,4.666,4.666,0,1,1,9.333,0A.667.667,0,1,0,15,20,6.006,6.006,0,0,0,9,14Z"
                        transform="translate(0 -4.667)"
                        fill="#adadad"
                      />
                    </g>
                  </svg>

                  <input
                    class="block bg-inputbg pl-12 rounded-[5px] h-14 w-full text-black leading-tight focus:outline-none focus:bg-gray-200"
                    :class="[
                      errorsKey.includes('first_name')
                        ? 'border-2 border-red-300 bg-red-100 '
                        : '',
                    ]"
                    required
                    type="text"
                    placeholder="First Name"
                    v-model="first_name"
                  />
                </label>
              </div>

              <div class="flex flex-col w-full">
                <label
                  class="relative p-0 my-2 text-gray-400 w-full bg-white focus-within:text-gray-600 block"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.999"
                    height="15.999"
                    viewBox="0 0 11.999 15.999"
                    class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
                  >
                    <g
                      id="user_3_"
                      data-name="user (3)"
                      transform="translate(-3)"
                    >
                      <path
                        id="Path_25867"
                        data-name="Path 25867"
                        d="M10,8A4,4,0,1,0,6,4a4,4,0,0,0,4,4Zm0-6.666A2.666,2.666,0,1,1,7.333,4,2.666,2.666,0,0,1,10,1.333Z"
                        transform="translate(-1)"
                        fill="#adadad"
                      />
                      <path
                        id="Path_25868"
                        data-name="Path 25868"
                        d="M9,14a6.006,6.006,0,0,0-6,6,.667.667,0,1,0,1.333,0,4.666,4.666,0,1,1,9.333,0A.667.667,0,1,0,15,20,6.006,6.006,0,0,0,9,14Z"
                        transform="translate(0 -4.667)"
                        fill="#adadad"
                      />
                    </g>
                  </svg>

                  <input
                    class="block bg-inputbg pl-12 appearance-none rounded-[5px] h-14 w-full text-black leading-tight focus:outline-none focus:bg-gray-200"
                    :class="[
                      errorsKey.includes('last_name')
                        ? 'border-2 border-red-300 bg-red-100 '
                        : '',
                    ]"
                    type="text"
                    required
                    placeholder="Last Name"
                    v-model="last_name"
                  />
                </label>
              </div>
            </div>
            <div class="flex flex-row justify-around w-full"></div>
            <label
              class="relative p-0 my-2 text-gray-400 bg-white focus-within:text-gray-600 block"
            >
              <svg
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
                xmlns="http://www.w3.org/2000/svg"
                width="12.659"
                height="11.604"
                viewBox="0 0 12.659 11.604"
              >
                <path
                  id="envelope_2_"
                  data-name="envelope (2)"
                  d="M10.022,1H2.637A2.64,2.64,0,0,0,0,3.637v6.33A2.64,2.64,0,0,0,2.637,12.6h7.384a2.64,2.64,0,0,0,2.637-2.637V3.637A2.64,2.64,0,0,0,10.022,1ZM2.637,2.055h7.384a1.582,1.582,0,0,1,1.466,1L7.449,7.09a1.586,1.586,0,0,1-2.239,0L1.171,3.05a1.582,1.582,0,0,1,1.466-1Zm7.384,9.494H2.637A1.582,1.582,0,0,1,1.055,9.967V4.428l3.41,3.407a2.641,2.641,0,0,0,3.73,0L11.6,4.428V9.967A1.582,1.582,0,0,1,10.022,11.549Z"
                  transform="translate(0 -1)"
                  fill="#adadad"
                />
              </svg>

              <input
                @blur="validateEmail"
                class="block bg-inputbg pl-12 appearance-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                :class="[
                  errorsKey.includes('email')
                    ? 'border-2 border-red-300  '
                    : '',
                ]"
                for="email"
                type="email"
                required
                placeholder="Email"
                v-model="email"
              />
              <!-- <input
                                for="email"
                                type="email"
                                placeholder="Please enter your email here"
                                required
                                v-model="email"
                                @blur="validateEmail"
                            /> -->
            </label>
            <p
              class="text-red-600 text-xs italic"
              v-if="errorsKey.includes('email')"
            >
              {{ errors.email[0] }}
            </p>
            <div class="flex flex-row gap-2 w-full">
              <div class="flex flex-col w-full">
                <label
                  class="relative p-0 my-2 text-gray-400 w-full bg-white block"
                >
                  <svg
                    class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3 opacity-30 z-10"
                    fill="#000000"
                    height="64px"
                    width="64px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    xml:space="preserve"
                    stroke="#000000"
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0" />

                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#CCCCCC"
                      stroke-width="2.048"
                    />

                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M93.8,114.6c-4.7,1.1-1.7,0.9-5.6,1.4C71.5,119.6,83.9,122.8,93.8,114.6z M387.5,121.3c1.2-0.8,5.4-4.9-7.7-8.9 c0.8,4.1-2.7,3.7-2.7,6c9.7,8.8,13.7,24.1,26.1,27.3C405.6,134.7,392.2,129.3,387.5,121.3z M84.9,111.4c1.5,8.9,8.2-9.4,8.3-15.9 c-2.6,1.5-5.2,3-7.9,4.2c6.3,3.2,0.8,6.6-6,11.7C65.5,128.6,92.2,98,84.9,111.4z M256,0C114.6,0,0,114.6,0,256 c0,141.3,114.6,256,256,256c141.4,0,256-114.7,256-256C512,114.6,397.4,0,256,0z M262.8,85.8l1.2,0.4c-4.8,6.2,25,24.3,3.6,25.8 c-20,5.7,8.4-5.2-7.1-3.3C268.7,97.3,254,97.1,262.8,85.8z M141.4,102.2c-7.2-6-29.8,8.2-21.9,4.8c19.6-7.7,1.3,0.8,5.9,10 c-4.2,8.7-1.4-8.6-11.8,1.7c-7.5,1.7-25.9,18.7-23.6,13.5c-0.6,8.1-21.9,17.7-24.8,31.2c-7,18.7-1.7-0.7-3-8 c-10-12.7-28.2,21.5-22.8,35c9.1-16,8.4-1.7,1.8,5.4c6.7,12.3-6.1,28.3,6.6,37.4c5.6,1.3,16.8-18.8,11.9,2.1 c3.4-18.1,9.4,4.3,19.1-0.7c0.6,9.5,6.5,5.1,7.8,16.6c16.2-1.2,31,26.2,11.7,31.4c2.9-0.8,8.6,4.3,15.2,0.4 c11.2,8.9,40.7,10,41.5,32c-20.3,9.7-5,36.3-22.6,45.8c-20.2-3-6.9,24.9-15.4,21.7c3.4,20.1-20.4-2.6-11.2,8.5 c16.9,10.4-7.4,8.3,0.2,15.9c-8.5-1.8,5.3,15.8,7.6,22.3c12.2,19.8-10.5-4.4-17.2-11c-6.4-12.8-21.5-37.3-25.7-57.4 c-2.4-29.2-25-48.8-30.2-77.3c-5.2-15.9,14.3-41.4,3.8-50.3c-9.1-7.1-5.4-31.4-10.8-44.2c13.5-58.5,56.4-107.8,107.9-137 c-5.3,3.9,30.3-10.1,26.2-6.7c-1.1,2.5,20.8-9.5,34-11.3c-1.4,0.2-34.3,12-25.2,10.4c-14.1,6.9-1.4,3,5.6-0.5 c-14,10.3-24.8,7.4-40.7,16.5c-16,4.2-12.7,20.8-24.1,29.1c6.7,1.2,23.5-17.3,33.3-23.8c22.5-10.9-11.4,19.8,10,6.6 c-7.2,6.7-5.7,17.4-10.1,20.4C148.2,92.1,159.1,97.9,141.4,102.2z M176.4,56.2c-2.3,3.1-5.5,9.8-7.4,5.7c-2.6,1.3-3.6,6.9-8.5,2.4 c2.9-2.1,5.9-7.1,0.2-4c2.6-2.8,25.8-10.7,24.5-13.7c4.1-2.6,3.7-3.9-1-2.3c-2.4-0.8,5.7-7.6,16.5-8.5c1.5,0,2.1,1-0.6,0.7 c-16.3,5-9.3,3.6,1.7,0c-4.2,2.4-7.1,3.1-7.8,4.2c11-4-0.6,2.9,1.9,2.4c-3.1,1.6,0.5,2.1-5.5,4.4c1.1-0.9-9.8,6.5-3.3,4.3 C180.8,57.8,178,57.9,176.4,56.2z M186,70.5c0.2-9.6,14-15.7,12.3-16.2c17-8-5.9,0.3,7.5-6.9c5-0.5,15.6-16.5,30.3-17.5 c16.2-4.9,8.7,0.3,20.7-4.3l-2.4,2c-2.1,0.3,0.5,4-7.1,9.6c-0.8,8.7-14.5,4.7-7.7,14c-4.4-6.3-11-0.2-2.7,0.4 c-8.9,6.8-29.6,8-39.5,19.3C191,80.1,185.1,77.2,186,70.5z M257.1,102.5c-6.8,16.4-13.4-2.4-1.4-5.4 C258.7,98.7,259.9,99.2,257.1,102.5z M231.5,69.7c-2-7.4-0.4-3.5,11.5-7C251.2,68.6,235.7,72.5,231.5,69.7z M417.7,363.2 c-9.4-16.2,11.4-31.2,18.4-44.8C435.2,334.3,433.2,350,417.7,363.2z M453.1,178.1c-10.2,0.8-19.4,3.2-28.6-2.6 c-21.2-23.2,3.9,26.2,10.9,6c25.2,9.6-0.4,51-16.3,46.7c-8.9-19.2-19.9-40.3-39.3-49.7c14.9,16.5,22.3,36.8,38.3,51.7 c1.1,20.8,22.2-7.6,20.9,8.5c2,27.7-31.3,44.3-25.5,72.1c12.4,25.3-23.9,29.9-19.8,52.6c-14.6,16.3-30.2,38.3-56.4,34.8 c0-13.8-7-25.5-8.6-39.7c-14.2-18,15-37.3-3.1-56.1c-20.9-4.7,4.3-33.5-17.2-30.8c-12.9-12.9-31.8-0.4-50.3-0.3 c-23.2,2.2-47.1-28.5-36.8-50.2c-8.2-22.6,26-29.2,26.9-49.1c16.4-13.7,39.7-12,61.9-15.2c-1.6,15.9,15.2,16,27.9,21.3 c7.1-17.2,29.2,2.8,44.3-8.1c5.2-25.4-14.7-10.1-26.1-18.2c-13.8-20.2,29.5-10.4,25-21c-16.8-0.1-7.3-20.7-19.2-9.2 c10.7,1.9-1.9,10.3-1.6,0.7c-16.2-4.7-0.6,18.4-8.8,20.6c-12.5-5.2-6.6,5.9-5.3,7.6c-5.4,11.7-12-17.2-27.3-16.4 c-15.2-13.9-6,6.3,7.2,9.6c-2.8,0.8,1.6,12.3-1.9,7.4c-10.9-15-31.6-25-43.9-6.6c-1.3,17.2-36.3,22.1-30.7,2 c-8.2-20.8,25.4-0.6,22.3-17.2c-21.6-14.3,5.9-9.7,13.2-23.1c16.6,0.5,0.7-13.6,8.5-17.7c-0.8,15.3,12.7,12.4,23.4,9.5 c-2.6-8.8,6.4-8.5,0.9-15.8c24.8-9.9-18.9,4.6-10.1-17.1c-10.7-7.4-4.5,16.3,0,18.8c0.3,7.3-5.9,16.3-14.4,1 c-12.4,8.1-11.1-8.2-11.9-6.5c-1.4-6.3,9.4-6.6,9.5-17.6c-0.9-7-0.7-10.7,4.3-11.1c0.4,1,20.5,1.3,27.6,9.6 c-19.4-3.9-2.9,3.2,5.8,7.2c-9.3-7.3,3.7,0-3.9-8.3c3,0.6-8.3-11.4,3.3-0.9c-6.3-7.5,12.3-5.3,1.3-10.9c16.1,4.5,6.6,0.4-2.9-3.7 c-26.2-15.6,46.3,21.1,16.7,4.8c18.9,4.1-40.4-14.6-13.4-6.4c-10.3-4.5-0.3-2,9,0.9c-16.7-5.2-41.7-14.9-40.7-15.3 c5.8,0.4,11.5,1.7,17,3.3c17.1,5.1-4.9-1.2-0.2-1.1C373.8,44,425.3,83.4,456.6,134.9c7.3,7.7,27.2,58.6,16.8,36 c4.7,18,5.4,37.4,7.9,55.8c-5.2-5.8-11-27.2-16-39.1C463.2,192.2,460.8,181.1,453.1,178.1z"
                      />
                    </g>
                  </svg>
                  <v-select
                    class="block pl-10 custom-select2 rounded-[5px] h-14 w-full py-3 bg-inputbg"
                    placeholder="Choose Your Region"
                    :options="countryOptions"
                    :searchable="false"
                    v-model="selectedCountry"
                    @input="updateCountryCode"
                    required
                  ></v-select>
                </label>
              </div>

              <div class="flex flex-col w-full">
                <label
                  class="relative p-0 my-2 text-gray-400 w-full bg-white focus-within:text-gray-600 block"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.076"
                    height="15.115"
                    viewBox="0 0 10.076 15.115"
                    class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
                  >
                    <g id="smartphone" transform="translate(-4)">
                      <path
                        id="Path_26661"
                        data-name="Path 26661"
                        d="M10.927,0H7.149A3.153,3.153,0,0,0,4,3.149v8.817a3.153,3.153,0,0,0,3.149,3.149h3.779a3.153,3.153,0,0,0,3.149-3.149V3.149A3.153,3.153,0,0,0,10.927,0ZM7.149,1.26h3.779a1.889,1.889,0,0,1,1.889,1.889v6.927H5.26V3.149A1.889,1.889,0,0,1,7.149,1.26Zm3.779,12.6H7.149A1.889,1.889,0,0,1,5.26,11.966v-.63h7.557v.63A1.889,1.889,0,0,1,10.927,13.855Z"
                        fill="#adadad"
                      />
                      <circle
                        id="Ellipse_1292"
                        data-name="Ellipse 1292"
                        cx="0.528"
                        cy="0.528"
                        r="0.528"
                        transform="translate(8.51 11.947)"
                        fill="#adadad"
                      />
                    </g>
                  </svg>

                  <input
                    class="block bg-inputbg pl-12 outline-none appearance-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                    :class="[
                      errorsKey.includes('mobile')
                        ? 'border-2 border-red-300 bg-red-100 '
                        : '',
                    ]"
                    required
                    type="number"
                    :placeholder="[
                      selectedCountry != null && selectedCountry.value === 'SA'
                        ? '+966'
                        : '+20',
                    ]"
                    v-model="mobileNumber"
                  />
                </label>
                <p
                  class="text-red-600 text-xs italic"
                  v-if="errorsKey.includes('mobile')"
                >
                  {{ errors.mobile[0] }}
                </p>
              </div>
            </div>
            <label
              class="relative p-0 my-2 text-gray-400 bg-white focus-within:text-gray-600 block"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11.833"
                height="14.2"
                viewBox="0 0 11.833 14.2"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              >
                <g id="lock" transform="translate(-2)">
                  <path
                    id="Path_25415"
                    data-name="Path 25415"
                    d="M12.058,4.984V4.142a4.142,4.142,0,1,0-8.283,0v.843A2.958,2.958,0,0,0,2,7.692v3.55A2.962,2.962,0,0,0,4.958,14.2h5.917a2.962,2.962,0,0,0,2.958-2.958V7.692A2.958,2.958,0,0,0,12.058,4.984Zm-7.1-.843a2.958,2.958,0,1,1,5.917,0v.592H4.958Zm7.692,7.1a1.775,1.775,0,0,1-1.775,1.775H4.958a1.775,1.775,0,0,1-1.775-1.775V7.692A1.775,1.775,0,0,1,4.958,5.917h5.917A1.775,1.775,0,0,1,12.65,7.692Z"
                    transform="translate(0)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25416"
                    data-name="Path 25416"
                    d="M11.592,14a.592.592,0,0,0-.592.592v1.183a.592.592,0,1,0,1.183,0V14.592A.592.592,0,0,0,11.592,14Z"
                    transform="translate(-3.675 -5.717)"
                    fill="#adadad"
                  />
                </g>
              </svg>

              <input
                class="block bg-inputbg pl-12 appearance-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                :class="[
                  errorsKey.includes('password')
                    ? 'border-2 border-red-300 bg-red-100 '
                    : '',
                ]"
                required
                :type="[enable ? 'text' : 'password']"
                placeholder="Password"
                v-model="password"
              />

              <svg
                class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 35 35"
                @click="enablePass()"
                v-if="enable == false"
              >
                <g
                  id="Group_16847"
                  data-name="Group 16847"
                  transform="translate(-0.4)"
                >
                  <path
                    id="eye-crossed"
                    d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                    transform="translate(8.768 8.494)"
                  />
                  <circle
                    id="Ellipse_1214"
                    data-name="Ellipse 1214"
                    cx="17.5"
                    cy="17.5"
                    r="17.5"
                    transform="translate(0.4)"
                    fill="none"
                    opacity="0.3"
                  />
                </g>
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.315"
                height="11.923"
                viewBox="0 0 15.315 11.923"
                class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
                v-if="enable == true"
                @click="enablePass()"
              >
                <g id="eye" transform="translate(0.004 -2.655)">
                  <path
                    id="Path_26662"
                    data-name="Path 26662"
                    d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="Path_26663"
                    data-name="Path 26663"
                    d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                    transform="translate(-2.536 -1.573)"
                  />
                </g>
              </svg>
            </label>
            <p
              class="text-red-600 text-xs italic"
              v-if="errorsKey.includes('password')"
            >
              The password must be at least 8 characters.
            </p>
            <label
              class="relative p-0 my-2 text-gray-400 bg-white focus-within:text-gray-600 block"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11.833"
                height="14.2"
                viewBox="0 0 11.833 14.2"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              >
                <g id="lock" transform="translate(-2)">
                  <path
                    id="Path_25415"
                    data-name="Path 25415"
                    d="M12.058,4.984V4.142a4.142,4.142,0,1,0-8.283,0v.843A2.958,2.958,0,0,0,2,7.692v3.55A2.962,2.962,0,0,0,4.958,14.2h5.917a2.962,2.962,0,0,0,2.958-2.958V7.692A2.958,2.958,0,0,0,12.058,4.984Zm-7.1-.843a2.958,2.958,0,1,1,5.917,0v.592H4.958Zm7.692,7.1a1.775,1.775,0,0,1-1.775,1.775H4.958a1.775,1.775,0,0,1-1.775-1.775V7.692A1.775,1.775,0,0,1,4.958,5.917h5.917A1.775,1.775,0,0,1,12.65,7.692Z"
                    transform="translate(0)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25416"
                    data-name="Path 25416"
                    d="M11.592,14a.592.592,0,0,0-.592.592v1.183a.592.592,0,1,0,1.183,0V14.592A.592.592,0,0,0,11.592,14Z"
                    transform="translate(-3.675 -5.717)"
                    fill="#adadad"
                  />
                </g>
              </svg>

              <input
                :class="[Checkistwins ? 'text-black' : 'text-red-600']"
                class="block bg-inputbg pl-12 appearance-none border-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                :type="[_enable ? 'text' : 'password']"
                placeholder="Confirm Password"
                v-model="confirmPassword"
                required
              />
              <svg
                class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 35 35"
                @click="enablePassV()"
                v-if="_enable == false"
              >
                <g
                  id="Group_16847"
                  data-name="Group 16847"
                  transform="translate(-0.4)"
                >
                  <path
                    id="eye-crossed"
                    d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                    transform="translate(8.768 8.494)"
                  />
                  <circle
                    id="Ellipse_1214"
                    data-name="Ellipse 1214"
                    cx="17.5"
                    cy="17.5"
                    r="17.5"
                    transform="translate(0.4)"
                    fill="none"
                    opacity="0.3"
                  />
                </g>
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.315"
                height="11.923"
                viewBox="0 0 15.315 11.923"
                class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
                v-if="_enable == true"
                @click="enablePassV()"
              >
                <g id="eye" transform="translate(0.004 -2.655)">
                  <path
                    id="Path_26662"
                    data-name="Path 26662"
                    d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="Path_26663"
                    data-name="Path 26663"
                    d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                    transform="translate(-2.536 -1.573)"
                  />
                </g>
              </svg>
            </label>
            <div class="flex items-center justify-center">
              <label class="p-0" @click="acceptTremV()">
                <svg
                  v-if="_clicked"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g
                    id="svgexport-6_-_2022-10-27T125207.565"
                    data-name="svgexport-6 - 2022-10-27T125207.565"
                    transform="translate(-2 -2)"
                  >
                    <g id="check">
                      <path
                        id="Path_26715"
                        data-name="Path 26715"
                        d="M19,2H5A3.009,3.009,0,0,0,2,5V19a3.009,3.009,0,0,0,3,3H19a3.009,3.009,0,0,0,3-3V5A3.009,3.009,0,0,0,19,2Zm-2.54,8.21-5,5a1.014,1.014,0,0,1-1.42,0l-2.5-2.5a1,1,0,0,1,1.42-1.42l1.79,1.8,4.29-4.3a1,1,0,1,1,1.42,1.42Z"
                        fill="#369da3"
                      />
                    </g>
                  </g>
                </svg>

                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g
                    id="svgexport-6_-_2022-10-27T125207.565"
                    data-name="svgexport-6 - 2022-10-27T125207.565"
                    transform="translate(-2 -2)"
                  >
                    <g id="check">
                      <path
                        id="Path_26715"
                        data-name="Path 26715"
                        d="M19,2H5A3.009,3.009,0,0,0,2,5V19a3.009,3.009,0,0,0,3,3H19a3.009,3.009,0,0,0,3-3V5A3.009,3.009,0,0,0,19,2Zm-2.54,8.21-5,5a1.014,1.014,0,0,1-1.42,0l-2.5-2.5a1,1,0,0,1,1.42-1.42l1.79,1.8,4.29-4.3a1,1,0,1,1,1.42,1.42Z"
                        fill="#d6d6d6"
                      />
                    </g>
                  </g>
                </svg>
              </label>
              <label
                for="link-checkbox"
                class="ml-0 py-0 text-[14px] text-black"
              >
                I agree with the
                <a
                  href="https://www.dkilo.com/advertiser-terms"
                  target="_blank"
                  class="text-primary hover:underline"
                  >Terms of Service,
                </a>
                <a
                  href="https://www.dkilo.com/privacy-policy"
                  target="_blank"
                  class="text-primary hover:underline"
                >
                  Privacy Policy
                </a>
                <span class="text-black hover:no-underline mx-[2x]">and</span>
                <a
                  href="https://www.dkilo.com/advertising-policies"
                  target="_blank"
                  class="text-primary hover:underline"
                >
                  Advertising Policies .</a
                >
              </label>
            </div>
            <p
              v-if="formIsValid"
              class="text-red-600 text-center -mt-3 rounded-sm mb-1"
            >
              You need to agree to our terms of services and privacy policy.
            </p>
            <button class="bg-primary text-white rounded-[5px] py-4 w-full">
              Submit
            </button>
          </div>
        </div>
      </form>
      <div v-else class="l-form">
        <p class="text-[25px] font-bold mb-[22px]">
          Please take a moment to verify <br />
          your email address.
        </p>
        <p class="text-[16px] text-opacity-90 mb-[41px]">
          We have sent an email to
          <span class="text-primary">{{ email }}</span> with a confirmation link
          to get access to dkilo Ads Manager
        </p>
        <button
          @click="toSignIn"
          class="mb-[11px] border-[2px] border-primary text-primary rounded-[5px] w-[123px] h-[40px] text-[12px] font-semibold"
        >
          Take me to Sign in
        </button>
        <p class="text-[12px] font-light">
          <span class="font-semibold"> Note:</span> Make sure you check your
          spam or junk folder too if you have trouble finding the confirmation
          link.
        </p>
      </div>
    </div>
    <div class="l-form form-container sign-in-container bg-white">
      <form @submit.prevent="signIn()">
        <div class="">
          <h1 class="font-bold text-[37px] mb-6 text-left">Sign in</h1>
          <label
            class="relative p-0 my-2 text-gray-400 bg-white focus-within:text-gray-600 block"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              class="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g
                id="Group_16107"
                data-name="Group 16107"
                transform="translate(-683 -292)"
              >
                <circle
                  id="Ellipse_1211"
                  data-name="Ellipse 1211"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(683 292)"
                  fill="none"
                  opacity="0.3"
                />
                <path
                  id="envelope_2_"
                  data-name="envelope (2)"
                  d="M13.221,1H3.479A3.483,3.483,0,0,0,0,4.479v8.35a3.483,3.483,0,0,0,3.479,3.479h9.742A3.483,3.483,0,0,0,16.7,12.829V4.479A3.483,3.483,0,0,0,13.221,1ZM3.479,2.392h9.742A2.088,2.088,0,0,1,15.155,3.7L9.827,9.034a2.092,2.092,0,0,1-2.953,0L1.545,3.7A2.088,2.088,0,0,1,3.479,2.392Zm9.742,12.525H3.479a2.088,2.088,0,0,1-2.088-2.088V5.523l4.5,4.5a3.484,3.484,0,0,0,4.921,0l4.5-4.5v7.306A2.088,2.088,0,0,1,13.221,14.917Z"
                  transform="translate(692.15 300.846)"
                  fill="#adadad"
                />
              </g>
            </svg>

            <input
              class="block pl-12 bg-inputbg appearance-none border-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
              type="email"
              placeholder="Email"
              v-model="inEmail"
              required
              @blur="validateEmail"
            />
          </label>
          <label
            class="relative p-0 my-6 text-gray-400 bg-white focus-within:text-gray-600 block"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              class="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g
                id="Group_16110"
                data-name="Group 16110"
                transform="translate(-496 -354)"
              >
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(496 354)"
                  fill="none"
                  opacity="0.3"
                />
                <g id="lock" transform="translate(503.917 362.4)">
                  <path
                    id="Path_25415"
                    data-name="Path 25415"
                    d="M14.892,6.388V5.308a5.308,5.308,0,1,0-10.617,0v1.08A3.792,3.792,0,0,0,2,9.858v4.55A3.8,3.8,0,0,0,5.792,18.2h7.583a3.8,3.8,0,0,0,3.792-3.792V9.858A3.792,3.792,0,0,0,14.892,6.388Zm-9.1-1.08a3.792,3.792,0,1,1,7.583,0v.758H5.792Zm9.858,9.1a2.275,2.275,0,0,1-2.275,2.275H5.792a2.275,2.275,0,0,1-2.275-2.275V9.858A2.275,2.275,0,0,1,5.792,7.583h7.583A2.275,2.275,0,0,1,15.65,9.858Z"
                    transform="translate(0)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25416"
                    data-name="Path 25416"
                    d="M11.758,14a.758.758,0,0,0-.758.758v1.517a.758.758,0,0,0,1.517,0V14.758A.758.758,0,0,0,11.758,14Z"
                    transform="translate(-2.175 -3.383)"
                    fill="#adadad"
                  />
                </g>
              </g>
            </svg>

            <input
              class="block bg-inputbg pl-12 appearance-none border-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
              :type="[enable ? 'text' : 'password']"
              placeholder="Password"
              v-model="inPassword"
              required
            />
            <svg
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              @click="enablePass()"
              v-if="enable == false"
            >
              <g
                id="Group_16847"
                data-name="Group 16847"
                transform="translate(-0.4)"
              >
                <path
                  id="eye-crossed"
                  d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                  transform="translate(8.768 8.494)"
                />
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(0.4)"
                  fill="none"
                  opacity="0.3"
                />
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.315"
              height="11.923"
              viewBox="0 0 15.315 11.923"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              v-if="enable == true"
              @click="enablePass()"
            >
              <g id="eye" transform="translate(0.004 -2.655)">
                <path
                  id="Path_26662"
                  data-name="Path 26662"
                  d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_26663"
                  data-name="Path 26663"
                  d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                  transform="translate(-2.536 -1.573)"
                />
              </g>
            </svg>
          </label>
          <div
            class="font-normal text-red-600 flex justify-center"
            v-if="signinErrors.length"
          >
            <!-- Whoops! Something went wrong. Please enter a valid Email address -->
            {{ signinErrors }}
          </div>
          <p v-if="!signinErrors" class="text-red-600 flex justify-center">
            please enter a valid email and password
          </p>
          <div
            class="font-normal text-red-600 flex justify-center"
            v-if="afterMailSend"
          >
            {{ message }}
          </div>

          <div
            class="font-normal text-red-600 flex justify-center"
            v-if="checkEmail"
          >
            Please enter your email !
          </div>

          <button
            class="bg-primary text-white rounded-[5px] py-4 w-full mt-[6%]"
          >
            Submit
          </button>
          <div class="mt-[40px]">
            <p
              class="text-[#8C8C8C] cursor-pointer text-center"
              @click="goTo()"
            >
              Forgot Password ?
            </p>
          </div>
        </div>
      </form>
    </div>

    <div class="overlay-container">
      <div class="overlay">
        <div class="overlay-panel overlay-left h-100 flex flex-col items-start justify-center py-[7%] px-10 md:px-20 text-left">
          <!-- Group Logo, Texts, and Button together -->
          <div class="flex flex-col gap-3 md:gap-6 items-start">
            <img src="../assets/white-logo.svg" class="h-[65px] w-[120px]" />
            <p class="text-lg text-white">DOOH advertising</p> <!-- Added text -->
            <div class="text-white mt-8 md:mt-16"> <!-- Increased top margin -->
              <!-- Original Sign Up Text -->
              <p class="text-[28px] font-normal">Online Ads Manager</p>
              <p class="text-[37px] font-bold pb-6">Get started for free</p>
            </div>
            <!-- Moved and Reordered Sign In Prompt -->
            <div class="mt-auto pt-6 md:pt-16"> <!-- Push to bottom -->
              <p class="text-[16px] text-white mb-4">Already have an account?</p>
              <button class="bg-white text-primary rounded-[5px] py-2 px-12 font-semibold" id="signIn">
                Sign In
              </button>
            </div>
          </div>
        </div>
        <div class="overlay-panel overlay-right h-100 flex flex-col items-start justify-center py-[7%] px-10 md:px-20 text-left pt-7">
          <!-- Group Logo, Texts, and Button together -->
          <div class="flex flex-col gap-3 md:gap-4 items-start"> <!-- Reduced gap -->
              <img src="../assets/white-logo.svg" class="h-[65px] w-[120px]" />
              <p class="text-lg text-white">DOOH advertising</p> <!-- Added text -->
              <div class="text-white mt-4 md:mt-6"> <!-- Added top margin -->
                <p class="text-[37px] font-bold">Welcome back!</p>
              </div>
              <!-- Moved and Reordered Sign Up Prompt -->
              <div class="mt-auto pt-6 md:pt-10"> <!-- Push to bottom -->
                  <p class="text-[16px] text-white mb-4">Don't have an account?</p>
                  <button class="bg-white text-primary rounded-[5px] py-2 px-12 font-semibold" id="signUp">
                      Sign Up
                  </button>
              </div>
          </div>
          <!-- Removed the separate second div -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      email: "",
      password: "",
      formIsValid: false,
      formIsValidUp: false,
      _formIsValid: false,
      first_name: "",
      last_name: "",
      inEmail: "",
      mobileNumber: "",
      inPassword: "",
      confirmPassword: "",
      _clicked: false,
      clicked: true,
      enable: false,
      _enable: false,
      istwins: false,
      errors: [],
      signinErrors: [],
      errorsKey: [],
      errorsValue: [],
      isSuccesful: false,
      checkEmail: false,
      afterMailSend: false,
      msg: "",
      country_code: {},
      selectedCountry: null,
      mobileNumber: "",
      countryOptions: [
        { value: "EG", label: "Egypt" },
        { value: "SA", label: "KSA" },
      ],
    };
  },
  computed: {
    Checkistwins() {
      if (this.confirmPassword === this.password) {
        return true;
      }
    },
    isEmpty() {
      if (this.inEmail === null || this.inEmail === "") {
        return true;
      }
    },
  },
  methods: {
    updateCountryCode() {
      this.mobileNumber =
        this.selectedCountry && this.selectedCountry.value === "SA"
          ? "+966"
          : "+20";
    },
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.msg["email"] = "Please enter a valid email address";
      } else {
        this.msg["email"] = "";
      }
    },
    enablePassV() {
      this._enable = !this._enable;
    },
    enablePass() {
      this.enable = !this.enable;
    },
    acceptTrem() {
      this.clicked = !this.clicked;
      this.formIsValid = false;
    },
    acceptTremV() {
      this._clicked = !this._clicked;
      this.formIsValid = false;
    },
    goTo() {
      this.forgetPass();
    },
    async forgetPass() {
      try {
        store.commit("toggleLoading");
        if (this.isEmpty) {
          this.checkEmail = true;
          this.afterMailSend = false;
          this._formIsValid = false;
          store.commit("toggleLoading");
        } else {
          const res = await axios.post(
            "https://publish.dkilo.com/api/reset_password",
            {
              email: this.inEmail,
            }
          );
          this.afterMailSend = true;
          this.checkEmail = false;
          this._formIsValid = false;
          this.signinErrors = [];
          this.message = res.data.message;
          store.commit("toggleLoading");
        }
      } catch (error) {
        // this._formIsValid = true;
        this.signinErrors = [];
        this.afterMailSend = true;
        this.checkEmail = false;
        this._formIsValid = false;
        this.message = error.response.data.message;
        // console.log("err", this.message);
        store.commit("toggleLoading");
      }
    },
    async signIn() {
      try {
        store.commit("toggleLoading");
        await this.$store.dispatch("login", {
          email: this.inEmail,
          password: this.inPassword,
        });
        this.signinErrors = [];
        store.commit("toggleLoading");
      } catch (error) {
        this.signinErrors = error.response.data.message;
        this._formIsValid = true;
        this.afterMailSend = false;
        this.checkEmail = false;
        store.commit("toggleLoading");
      }
    },
    async submitForm() {
      this.errors = [];
      this.errorsKey = [];
      this.errorsValue = [];

      try {
        store.commit("toggleLoading");
        if (this._clicked == true) {
          await this.$store.dispatch("signUp", {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            country_code: this.selectedCountry.value,
            mobileNumber: this.mobileNumber,
            password: this.password,
          });
          store.commit("toggleLoading");
          this.isSuccesful = true;
        } else {
          store.commit("toggleLoading");
          this.formIsValid = true;
        }
      } catch (error) {
        store.commit("toggleLoading");
        this.errors = error.response.data;
        this.errorsKey = Object.keys(this.errors);
        this.errorsValue = Object.values(this.errors);
        this.formIsValidUp = true;
        this.formIsValid = false;
      }
    },
    toSignIn() {
      container.classList.remove("right-panel-active");
    },
  },
  mounted() {
    //Change Document Title
    document.title = "dKilo Ad Manager - Login";
    const signUpButton = document.getElementById("signUp");
    const signInButton = document.getElementById("signIn");
    const container = document.getElementById("container");
    signUpButton.addEventListener("click", () => {
      container.classList.add("right-panel-active");
    });
    signInButton.addEventListener("click", () => {
      container.classList.remove("right-panel-active");
    });
  },
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:400,800"); */
.custom-select {
  /* Your custom styles here */
  background-color: #ffffff;
  /* border: 1px solid #CCCCCC; */
  border-radius: 5px;
  padding: 0.5rem;
  width: 100%;
  font-size: 14px;
  color: #333333;
}

.custom-select2 .vs__dropdown-toggle {
  border: none !important;
}

.custom-select:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  /* border-left: 6px solid transparent;
        border-right: 6px solid transparent; */
  border-top: 6px solid #555555;
  transform: translateY(-50%);
}

.custom-select.open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-select option {
  background-color: #f1f1f1;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.l-form {
  background-color: #ffffff;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
  padding: 0 100px;
  height: 100%;
  /* text-align: center; */
}

.form-container {
  position: absolute;
  text-align: left;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}

.sign-in-container {
  /* right: 60%; */
  width: 50%;
  z-index: 2;
}

.container.right-panel-active .sign-in-container {
  transform: translateX(100%);
}

.sign-up-container {
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
}

.container.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
  animation: show 0.6s;
}

/* @keyframes show {
    0%,
    49.99% {
        opacity: 0;
        z-index: 1;
    }

    50%,
    100% {
        opacity: 1;
        z-index: 5;
    }
} */

.overlay-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}

.container.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

.overlay {
  /* background: #ff416c;
  background: -webkit-linear-gradient(to right, #ff4b2b, #ff416c);
  background: linear-gradient(to right, #ff4b2b, #ff416c); */
  background-image: url(../assets/photo1659285795.jpeg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
}

.container.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay-panel {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  /* padding: 0 40px; */
  /* text-align: center; */
  /* top: 0; */
  height: 100%;
  width: 50%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
}

.overlay-left {
  transform: translateX(-20%);
}

.container.right-panel-active .overlay-left {
  transform: translateX(0);
}

.overlay-right {
  right: 0;
  transform: translateX(0);
}

.container.right-panel-active .overlay-right {
  transform: translateX(20%);
}
</style>
